export const AppVisibility = {
  Public: 'public',
  Private: 'private',
  Hidden: 'hidden',
  Submitted: 'submitted',
  ReadyToLaunch: 'ready to launch',
  Rejected: 'rejected'
};
export const APP_LIST_NO_RESULT_TITLE = 'No apps to show';
export const APP_LIST_NO_RESULT_SUBTITLE = 'Try searching for a different name.';